import styled from '@emotion/styled';

import { inputFocusStyles, uppercaseLabelStyles } from './utils/mixins';
import { COLOR_BORDER, COLOR_BORDER_INPUT, COLOR_SURFACE_MUTED, RADIUS_LG, RADIUS_MD } from './utils/variables';

export const AddressSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid ${COLOR_BORDER};
  border-radius: ${RADIUS_LG};
  background: ${COLOR_SURFACE_MUTED};

  .form-group {
    margin-bottom: 12px;
  }

  .form-group:last-child {
    margin-bottom: 0;
  }

  .control-label {
    ${uppercaseLabelStyles}
    letter-spacing: 0.04em;
  }

  .form-control {
    border-radius: ${RADIUS_MD};
    border-color: ${COLOR_BORDER_INPUT};
    box-shadow: none;
  }

  .form-control:focus {
    ${inputFocusStyles}
  }
`;
